export default __webpack_public_path__ + "static/stacked-column-93fd4a6c2f5f25c00adc2f1550396bfc.png";